// extracted by mini-css-extract-plugin
export var container = "_9r-0";
export var icon = "_9r-1";
export var text = "_9r-2";